<div class="about-container">
  <div class="smooth-sail-section">
    <div class="title">We help you sail smoothly</div>
    <div class="content">
      Clinical laboratories are vital links in the continuum of healthcare. In
      today’s medical practice, over 75% of all prevention, treatment and
      diagnostic decisions are based on laboratory results. Laboratory reports
      constitute up to 70% of a patient’s medical record. The seamless service
      offered by a laboratory is the reflection of the highly evolved science
      that laboratory medicine is today.
    </div>
    <div class="circles">
      <div class="circle-flex">
        <div class="circle"></div>
        <div class="circle-text">Lorem ipsum</div>
      </div>
      <div class="circle-flex">
        <div class="circle"></div>
        <div class="circle-text">Lorem ipsum</div>
      </div>
      <div class="circle-flex">
        <div class="circle"></div>
        <div class="circle-text">Lorem ipsum</div>
      </div>
      <div class="circle-flex">
        <div class="circle"></div>
        <div class="circle-text">Lorem ipsum</div>
      </div>
    </div>
    <div class="content circle-content">
      In order to deliver an accurate and credible report, the laboratory
      operations begin with the right test, right patient preparation, right
      sample, right method, right report and right interpretation. The overall
      laboratory management process is managed by the laboratory medicine expert
      along with a team of trained technologists and scientists, besides the
      support team. The laboratory is not just about samples. It is the journey
      that a sample makes from a patient to the report generated.
    </div>
  </div>
  <div class="story-section">
    <div class="title">Our Story</div>
    <div class="story">
      <div class="content">
        The Laboratory “Matters” is all about the clinical laboratory. It is
        about all that matters in a laboratory to make it from a laboratory to
        THE Laboratory. The laboratory is resource intense and resonates with
        the passion of its personnel. A laboratory that can boast of having
        well-trained and insightful technologists and doctors is on the right
        path to being credible, patient centric, near zero error and smart.
        “Learning never exhausts the mind”. At The Laboratory Matters, our focus
        is on training, sharing and learning. “The illiterate of the 21st
        century will not be those who cannot read and write, but those who
        cannot learn, unlearn and relearn.
      </div>
      <div class="image-section">
        <img src="../../assets/images/story-image.png" alt="" />
      </div>
    </div>
  </div>
  <div class="values-section">
    <div class="title">Our Values</div>
    <div class="three-sections">
      <div class="mission-section">
        <div class="title">Mission</div>
        <div class="content">
          Our mission is to provide innovative, cost effective, value-based
          training delivered by committed and passionate trainers and leaders to
          enable the learners in their professional development and quest for
          excellence.
        </div>
      </div>
      <div class="vision-section">
        <div class="title">Vision</div>
        <div class="content">
          To become the preferred training provider beyond boundaries in the
          realm of laboratory medicine, thus enabling professional growth and
          clarity enhancing performance.
        </div>
      </div>
      <div class="goals-section">
        <div class="title">Goals</div>
        <div class="content">
          Make laboratories smart. Making laboratories zero-error tolerant.
          Sharing expertise and information and empathy. To enable a thought
          sharing and training platform for all laboratory medicine experts and
          to-be experts.
        </div>
      </div>
    </div>
  </div>
</div>
